import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "magnifying-glass",
  "use": "magnifying-glass-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 14\" id=\"magnifying-glass\"><path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M25.998 21.503a.748.748 0 0 1 .216.15l3.44 3.44a.75.75 0 0 1-1.061 1.06l-3.44-3.439a.748.748 0 0 1-.15-.216 5 5 0 1 1 .996-.996zM22 22.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8z\" transform=\"translate(-17 -13)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol